import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { api } from "../api/client";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const errParam = params.get("error");

      if (errParam) {
        setError(`Google returned an error: ${errParam}`);
        return;
      }
      if (!code) {
        setError("No authorization code returned by Google.");
        return;
      }

      // The redirect_uri sent to Google MUST match the one we send to the backend
      // so that Google's code-exchange validation succeeds.
      const redirectUri = window.location.origin + "/auth/google";

      try {
        const res = await api.post("/auth/google", { code, redirect_uri: redirectUri });
        if (res.data?.token && res.data?.user) {
          localStorage.setItem("auth_token", res.data.token);
          localStorage.setItem("auth_user", JSON.stringify(res.data.user));
          try { window.dispatchEvent(new Event("auth:changed")); } catch (e) { /* noop */ }
          navigate("/app", { replace: true });
        } else {
          setError("Unexpected response from server.");
        }
      } catch (e) {
        const detail = e?.response?.data?.detail || e?.message || String(e);
        setError(`Login failed: ${detail}`);
      }
    };

    run();
  }, [navigate]);

  return (
    <div style={{
      minHeight: "100vh",
      background: "#05070b",
      color: "#e5e7eb",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
    }}>
      <div style={{ textAlign: "center", maxWidth: 420 }}>
        {!error ? (
          <>
            <div style={{
              width: 48, height: 48, borderRadius: "50%",
              border: "3px solid rgba(255,255,255,0.1)",
              borderTopColor: "#10b981",
              margin: "0 auto 18px",
              animation: "gcb-spin 1s linear infinite",
            }} />
            <div style={{ fontSize: 18, fontWeight: 600 }}>Signing you in…</div>
            <div style={{ fontSize: 14, color: "rgba(226,232,240,0.6)", marginTop: 6 }}>
              Finishing up your Google sign-in.
            </div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 18, fontWeight: 700, color: "#f87171", marginBottom: 10 }}>
              Sign-in failed
            </div>
            <div style={{ fontSize: 14, color: "rgba(226,232,240,0.7)", marginBottom: 20 }}>
              {error}
            </div>
            <button
              onClick={() => navigate("/", { replace: true })}
              style={{
                padding: "10px 18px", borderRadius: 999,
                background: "linear-gradient(95deg,#10b981,#06b6d4)",
                color: "#03130c", border: "none", fontWeight: 700, cursor: "pointer",
              }}
            >
              Back to home
            </button>
          </>
        )}
        <style>{`@keyframes gcb-spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
